import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {criminalHistoryQuestionSelect} from '../../redux/selector/criminalDetailsSelector'
import {setCriminalHistoryQuestionAnswer} from '../../redux/slice/criminalHistorySlice'
import {
    Header, 
    Paragraph, 
    Button
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import {replaceCollectorName,replaceUrlParams} from '../../app/utils'

import { 
    APPLICATION_MODE_RENEW,
    APPLICATION_TYPE_COLLECTOR, 
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT, 
    ROUTE_PATH
} from '../../app/constants';
import Navigation from '../Navigation';
import { setCurrentAgentCriminalHistoryDetails } from '../../redux/slice/additionalApplicationsSlice'; 
import { setAgencyCriminalHistoryDetails } from '../../redux/slice/primaryAgencyApplicationSlice';

const criminalHistoryQuestion = (props) => {
    
    const {
        applicationType, 
        applicationMode
    } = props.match.params
    const {dispatch} = props
    const {collectorApplication} = props.criminalHistoryQuestion
    const criminalHistoryQuestion = props.criminalHistoryQuestion[applicationType] ? 
        props.criminalHistoryQuestion[applicationType] : props.criminalHistoryQuestion
    
    const handleYesNavigation = () => { 
        if(applicationMode === APPLICATION_MODE_RENEW 
            && criminalHistoryQuestion.navigationRenewal) {
                dispatch(push(replaceUrlParams(criminalHistoryQuestion.navigationRenewal.yes, applicationType, applicationMode)))
        } else { 
            dispatch(push(replaceUrlParams(criminalHistoryQuestion.navigation.yes, applicationType, applicationMode)))
        }
    }
    
    let paragraphText = criminalHistoryQuestion.text
    
    if(applicationMode === APPLICATION_MODE_RENEW) { 
        paragraphText = criminalHistoryQuestion.textRenewal
    }

    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
        let collectorName = (applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) ? "Debt Management Agent" : "Collector"

        if(collectorApplication 
            && collectorApplication.applicantDetails
            && collectorApplication.applicantDetails.firstName) {
            collectorName = collectorApplication.applicantDetails.firstName
        }

        paragraphText = paragraphText.map((text) => replaceCollectorName(text,collectorName))
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <TopNavigationBar {...props} />
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="criminal-history-question-header" 
                        header={criminalHistoryQuestion.header} />
                    <Paragraph 
                        id="criminal-history-question-text" 
                        text={paragraphText} />
                    <div className="row">
                        <div className="col-auto">
                            <Button 
                                id="criminal-history-question-yes"
                                text={"Yes"}
                                className="ns-btn-yes-no btn-default"
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    dispatch(setCriminalHistoryQuestionAnswer("yes"))
                                    handleYesNavigation()
                                }}
                            />
                        </div>
                        <div className="col-auto">
                            <Button 
                                id="criminal-history-question-no"
                                className="ns-btn-yes-no btn-default"
                                text={"No"}
                                buttonType={"regular_primary"}
                                onClick={() => {
                                    dispatch(setCriminalHistoryQuestionAnswer("no"))

                                    let nextUrl = criminalHistoryQuestion.navigation.no
                                    
                                    if(applicationType === APPLICATION_TYPE_COLLECTOR || 
                                        applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT) {
                                        dispatch(setCurrentAgentCriminalHistoryDetails([]))

                                        if(collectorApplication 
                                            && collectorApplication.licenceSuspendedData
                                            && Array.isArray(collectorApplication.licenceSuspendedData)
                                            && collectorApplication.licenceSuspendedData.length > 0) {
                                            nextUrl = ROUTE_PATH.LICENCE_SUSPENSION_DETAILS
                                        }
                                    } else { 
                                        dispatch(setAgencyCriminalHistoryDetails([]))

                                        if(applicationMode === APPLICATION_MODE_RENEW 
                                            && criminalHistoryQuestion.navigationRenewal) {
                                                nextUrl = criminalHistoryQuestion.navigationRenewal.no
                                        }
                                    }
                                    
                                    dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </div>
        </>
    )
}

export default connect(criminalHistoryQuestionSelect)(criminalHistoryQuestion)
